import React from "react";

interface LoadConfirmationDialogProps {
  isOpen: boolean;
  onCancel: () => void;
  onDiscardAndLoad: () => void;
  onSaveAndLoad: () => void;
  projectName: string;
}

export const LoadConfirmationDialog: React.FC<LoadConfirmationDialogProps> = ({
  isOpen,
  onCancel,
  onDiscardAndLoad,
  onSaveAndLoad,
  projectName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
      <div className="bg-gray-800 rounded-lg shadow-xl w-[480px] max-w-[90vw] border border-gray-700">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <div className="flex items-center gap-2">
            <span className="text-2xl">⚠️</span>
            <h2 className="text-lg font-semibold text-white">
              Unsaved Changes
            </h2>
          </div>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-white transition-colors"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-gray-300 text-sm">
            You have unsaved changes in your current project. Would you like to
            save before loading <strong>"{projectName}"</strong>?
          </p>
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-end gap-3 p-4 border-t border-gray-700">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-600 hover:bg-gray-500 text-white rounded transition-colors"
          >
            Cancel
          </button>

          <button
            onClick={onDiscardAndLoad}
            className="px-4 py-2 bg-red-600 hover:bg-red-500 text-white rounded transition-colors flex items-center gap-2"
          >
            <span>Discard & Load</span>
          </button>

          <button
            onClick={onSaveAndLoad}
            className="px-4 py-2 bg-green-600 hover:bg-green-500 text-white rounded transition-colors flex items-center gap-2"
          >
            <span>Save & Load</span>
          </button>
        </div>
      </div>
    </div>
  );
};
